export default __webpack_public_path__ + "static/media/SKS_Personal_History.0542c479.svg";